
























































































































import BaseMixin from '@/mixins/BaseMixin';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { PartCatalogueTree } from '@/entities/part-catalogue/PartCatalogueTree';
import { BreadcrumbData } from '@/entities/breadcrumb/Breadcrumb';
import PartCatalogueLandingPageBreadcrumb from '../breadcrumb/PartCatalogueLandingPageBreadcrumb.vue';
import { PartCatalogueService } from '@/services/part-catalogue-service';
import { PartCatalogueTreeNodeType } from '@/entities/part-catalogue/PartCatalogueTreeNodeType';
import { isNullOrWhitespace } from '@/helper/isNullOrWhitespace';

@Component({
    components: {
        PartCatalogueLandingPageBreadcrumb,
    },
})
export default class PartCatalogueLandingPage extends Mixins(BaseMixin) {
    private readonly partCatalogueService: PartCatalogueService = new PartCatalogueService();

    @Prop()
    private readonly tree!: PartCatalogueTree;

    @Prop()
    private readonly breadCrumb!: BreadcrumbData;

    @Prop()
    private currentId!: string;

    private get currentTree(): PartCatalogueTree {
        if (this.currentId) {
            const currentTree = this.partCatalogueService.getTreeNodeById(this.tree, this.currentId);
            return currentTree ? currentTree : this.tree;
        }

        return this.tree;
    }

    private get showDiagramPage(): boolean {
        return this.currentTree.children.every((node) => node.type === PartCatalogueTreeNodeType.Diagram);
    }

    private get pageBaseUrl(): string {
        return this.breadCrumb.items[0] ? this.breadCrumb.items[0].url : '';
    }

    private get showNavigationBar(): boolean {
        return (
            this.currentTree.type === PartCatalogueTreeNodeType.ModelGroup ||
            this.currentTree.type === PartCatalogueTreeNodeType.Model
        );
    }

    private get previousId(): string | null {
        return this.currentTree.parentTreeId;
    }

    private get hasPreviousId(): boolean {
        return !isNullOrWhitespace(this.previousId);
    }

    private getThumbnailImageUrl(id: string, type: PartCatalogueTreeNodeType): string {
        switch (type) {
            case PartCatalogueTreeNodeType.Brand:
                return this.partCatalogueService.getGroupThumbnailUrl(id);
            case PartCatalogueTreeNodeType.ModelGroup:
                return this.partCatalogueService.getGroupThumbnailUrl(id);
            case PartCatalogueTreeNodeType.Model:
                return this.partCatalogueService.getProjectThumbnailUrl(id);
            case PartCatalogueTreeNodeType.Diagram:
                return this.partCatalogueService.getAssemblyThumbnailInLowQualityUrl(id);
            default:
                return this.partCatalogueService.getGroupThumbnailUrl('-1');
        }
    }

    private assemblyThumbnailUrl(id: string): string {
        return this.partCatalogueService.getAssemblyThumbnailInLowQualityUrl(id);
    }

    private assemblyUrl(id: string): string {
        return `/PartCatalogue/Assembly/${id}`;
    }

    private onPartCatalogueItemClicked(groupId: string): void {
        this.currentId = groupId;
    }
}
